export const REFERRAL_LENGTH_MONTHS = 6;
export const REFERRAL_LENGTH_MONTHS_DISPLAY = 'six';
export const REFERRAL_LENGTH_DAYS = Math.floor((REFERRAL_LENGTH_MONTHS * 365) / 12);
export const REFERRAL_PAYOUT_RATE = 10;
